import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getToken } from "./../../utils/utils";

export const fetchSpace = createAsyncThunk(
  "fetchSpace",
  async (data, thunkAPI) => {
    const url = process.env.REACT_APP_API_URL + "/controller/space/list.php";
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.space;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchSpaceSearch = createAsyncThunk(
  "fetchSpaceSearch",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/space/search.php?search=" +
      data;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.space;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchSpaceEdit = createAsyncThunk(
  "fetchSpaceEdit",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/space/details.php?id=" +
      data.id;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.space[0];
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const saveSpace = createAsyncThunk(
  "saveSpace",
  async (data, thunkAPI) => {
    const url = process.env.REACT_APP_API_URL + "/controller/space/create.php";
    const authorization = getToken();
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.space) return result.data.space;
          else return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const editSpace = createAsyncThunk(
  "editSpace",
  async (data, thunkAPI) => {
    const url = process.env.REACT_APP_API_URL + "/controller/space/update.php";
    const authorization = getToken();
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.space) return result.data.space;
          else return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const deleteSpace = createAsyncThunk(
  "deleteSpace",
  async (id, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/space/delete.php?id=" + id;
    const authorization = getToken();
    const options = {
      method: "delete",
      headers: { Authorization: "Bearer " + authorization },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.status) {
          return result.status;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchSpaceToCalendar = createAsyncThunk(
  "fetchSpaceToCalendar",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/space/calendar.php";
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.space;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);
